import { render, staticRenderFns } from "./ConsultationForm.vue?vue&type=template&id=1c545edc&scoped=true"
import script from "./ConsultationForm.vue?vue&type=script&lang=js"
export * from "./ConsultationForm.vue?vue&type=script&lang=js"
import style0 from "./ConsultationForm.vue?vue&type=style&index=0&id=1c545edc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c545edc",
  null
  
)

export default component.exports